export default __webpack_public_path__ + "static/media/carDealer.1f0eae36.png";